require('./bootstrap');
require('owl.carousel2')
require('lightgallery');
require('jquery');